import src from "IMAGE";
export default { src, width: 400, height: 94, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AP9mAP7WVgDSXygAVFkmAE5oLABYYioAVGYrAFpkKwBRAP96KP7WZiLSXCcBUE0hAENkKgBRaS0AVYI3AHI+GgA0x5gTdpUmGjcAAAAASUVORK5CYII="};
